import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";
import { fetchBrands } from "../lib/api";

export default function Brands() {
  const { data: brands = [], isLoading } = useQuery({
    queryKey: ["all-brands"],
    queryFn: () => fetchBrands(),
    staleTime: 10 * 60 * 1000,
  });

  return (
    <div className="max-w-7xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-slate-900">All brands</h1>
      <p className="text-muted-foreground mt-2 max-w-2xl">
        OEM and compatible parts for major appliance brands — live from our catalog.
      </p>

      {isLoading ? (
        <div className="flex justify-center py-20 text-muted-foreground gap-2">
          <Loader2 className="h-6 w-6 animate-spin text-rp-green" />
          Loading brands…
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {brands.map((b) => (
            <Link
              key={b}
              to={`/boutique?brand=${encodeURIComponent(b)}`}
              className="card-lift bg-white border border-border rounded-xl p-6 flex flex-col items-center justify-center text-center"
            >
              <span className="font-display font-extrabold text-lg text-rp-green">{b}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
